<template>
  <div>
    <add-funds :accountDetails="accountDetails" v-if="getterPopupName === 'AddFunds'" />
    <bank-transfer v-else-if="getterPopupName === 'BankTransfer'"
          :manageAccess="manageAccess" @balanceAccess="updateBalanceAccess" />
    <verifications v-else-if="getterPopupName === 'Verifications'"
          :manageAccess="manageAccess" />
    <connected-bank-balance v-else-if="getterPopupName === 'ConnectedBankBalance'" />

    <account-details :accountDetails="accountDetails" :manageAccess="manageAccess"
          :loader="loader" :selfVa="selfVa" :lienAmount="lienAmount" />

    <unprivilege-panel v-if="getterUnprivilegePage === 'Account Statement'"
          :title="'Account Statement'" :css="'short-height'" />
    <account-transactions v-else :manageAccess="manageAccess"
          @balanceAccess="updateBalanceAccess" />
  </div>
</template>

<script>
import ConnectedBankBalance from '@/components/UPIs/Collections/ConnectedBankBalance'
import AddFunds from '@/components/AccountSummary/AddFunds'
import BankTransfer from '@/components/AccountSummary/BankTransfer'
import AccountDetails from '@/components/AccountSummary/AccountDetails'
import Verifications from '@/components/AccountSummary/Verifications'
import AccountTransactions from '@/components/AccountStatement/AccountTransactions'
import UnprivilegePanel from '@/components/global/UnprivilegePanel'

import ApiServices from '@/services/api/accountStatement'
import { mapMutations, mapGetters } from 'vuex'

export default {
  name: 'Dashboard',
  components: { AddFunds, BankTransfer, AccountDetails, AccountTransactions, UnprivilegePanel, Verifications, ConnectedBankBalance },
  data () {
    return {
      accountDetails: [],
      lienAmount: null,
      selfVa: {
        enabled: false,
        balance: 0
      },
      manageAccess: {
        accountBalance: true
      },
      loader: false
    }
  },
  created () {
    this.populateAccountDetails()
  },
  computed: {
    ...mapGetters(['getterPopupName', 'getterUnprivilegePage'])
  },
  methods: {
    ...mapMutations(['SET_ACCOUNT_BALANCE']),
    populateAccountDetails () {
      this.loader = true
      ApiServices.accountDetails().then((response) => {
        let data = response.data
        let privileges = response.privileges
        this.manageAccess = {
          accountBalance: privileges.account_balance,
          vaBalance: privileges.va_balance,
          accountDetails: privileges.account_details,
          fundTransfer: privileges.initiate_fund_transfers,
          bankVerify: privileges.initiate_bank_verifications,
          upiVerify: privileges.initiate_upi_verifications,
          connectedBankingBal: privileges.connected_banking_balance,
          connectedBankingPayout: privileges.connected_banking_payout,
          lienAmount: privileges.lien_amount
        }

        this.selfVa = {
          enabled: data.self_va_enabled,
          balance: data.total_va_balance
        }

        if (this.manageAccess.accountBalance) {
          this.SET_ACCOUNT_BALANCE(data.balance)
        }

        this.loader = false
        this.lienAmount = data.total_lien_amount || null
        this.accountDetails = [
          {
            title: 'Company Name',
            value: data.company_name
          }
        ]

        if (data.accounts) {
          this.accountDetails.push({
            arrayVal: this.getAccDetails(data.accounts)
          })
        }
      })
    },
    getAccDetails (accounts) {
      let list = {}
      for (let index in accounts) {
        const account = accounts[index]
        let data = [
          {
            title: 'A/C No.',
            value: account.number,
            copy: true
          },
          {
            title: 'IFSC',
            value: account.ifsc,
            copy: true
          },
          {
            title: 'Modes',
            value: account.payment_modes.join(' / ')
          }
        ]

        list[index] = data
      }

      return list
    },
    updateBalanceAccess (val) {
      this.manageAccess.accountBalance = val
    }
  }
}
</script>
